class Utils {

    static checkDate(birthdate) {
        const pattern = /^\d{2}\/\d{2}\/\d{4}$/;
        if (!pattern.test(birthdate)) return false;
        const [day, month, year] = birthdate.split('/');
        const numericYear = Number(year);
        const numericMonth = Number(month);
        const numericDay = Number(day);
        if (numericMonth < 1 || numericMonth > 12) return false;
        const lastDayOfMonth = new Date(numericYear, numericMonth, 0).getDate();
        if (numericDay < 1 || numericDay > lastDayOfMonth) return false;
        const adjustedDate = new Date(numericYear, numericMonth - 1, numericDay);
        if (
            adjustedDate.getDate() !== numericDay ||
            adjustedDate.getMonth() !== numericMonth - 1 ||
            adjustedDate.getFullYear() !== numericYear) {
            return false;
        }
        const isLeapYear = (numericYear % 4 === 0 && numericYear % 100 !== 0) || (numericYear % 400 === 0);
        if (numericMonth === 2 && (isLeapYear ? numericDay > 29 : numericDay > 28)) {
            return false;
        }
        return true;
    }
    
    static isValidDate(dateString) {
        const pattern = /^\d{2}\/\d{2}\/\d{4}$/;
        if (!pattern.test(dateString)) return false;
        const [day, month, year] = dateString.split('/');
        const numericYear = Number(year);
        const numericMonth = Number(month);
        const numericDay = Number(day);
        if (numericYear < 2020 || numericYear > 2050) return false;
        if (numericMonth < 1 || numericMonth > 12) return false;
        const lastDayOfMonth = new Date(numericYear, numericMonth, 0).getDate();
        if (numericDay < 1 || numericDay > lastDayOfMonth) return false;
        const adjustedDate = new Date(numericYear, numericMonth - 1, numericDay);
        const isValidDate = adjustedDate.getDate() === numericDay &&
                            adjustedDate.getMonth() === numericMonth - 1 &&
                            adjustedDate.getFullYear() === numericYear;
        const isLeapYear = (numericYear % 4 === 0 && numericYear % 100 !== 0) || (numericYear % 400 === 0);
        if (numericMonth === 2 && (isLeapYear ? numericDay > 29 : numericDay > 28)) {
            return false;
        }
        if (!isValidDate) return false;
        return true;
    }
    static checkEmail(email) {
        return (/^[a-z0-9._-]+@[a-z0-9]+\.[a-z]+(\.[a-z]+)?$/i).test(email);
    }    
}

export default Utils